import React from 'react'
import { ViewStyle } from 'react-native'

import styled from 'styled-components/native'

type MessengerUtilityItemContentContainerProps = React.PropsWithChildren<{
  style?: ViewStyle
  maxHeight?: string
}>

const Container = styled.View<{ maxHeight?: string }>(({ maxHeight }) => ({
  flexDirection: 'column',
  overflow: 'auto',
  ...(maxHeight && { maxHeight }),
}))

const MessengerUtilityItemContentContainer: React.FC<MessengerUtilityItemContentContainerProps> = ({
  style,
  children,
  maxHeight,
}) => {
  return (
    <Container style={style} maxHeight={maxHeight}>
      {children}
    </Container>
  )
}

export default MessengerUtilityItemContentContainer
